import { useQuery } from "@tanstack/react-query";
import { useAccessToken } from "@/hooks";
import { LocationsApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

export const useLocationGet = (id: number) => {
  const accessToken = useAccessToken();

  const { data, isError, isLoading, isSuccess, isPending, refetch } = useQuery({
    queryKey: [QueryKeys.Locations, id],
    queryFn: () => {
      if (!accessToken) {
        throw new Error("Authentication token is required");
      }
      const service = createAuthenticatedApi(LocationsApi, accessToken);
      return service.getLocationById({ id });
    },
    enabled: !!accessToken && !!id,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  return {
    data,
    isError,
    isLoading,
    isSuccess,
    isPending,
    refetch,
  };
};

